import { Box, Button, Group, Text } from "@mantine/core";
import { IconArrowsMove, IconTrash, IconX } from "@tabler/icons-react";
import { glassPanel } from "../lib/glass";

interface Props {
  assetName: string;
  onMove: () => void;
  onDelete: () => void;
  onDeselect: () => void;
}

export function AssetSelectionHUD({
  assetName,
  onMove,
  onDelete,
  onDeselect,
}: Props) {
  return (
    <Box
      style={{
        position: "absolute",
        bottom: 120,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 200,
        pointerEvents: "auto",
      }}
    >
      <Box
        p="xs"
        style={{
          ...glassPanel,
          borderRadius: 12,
        }}
      >
        <Group gap={8} mb={4} justify="center">
          <Text
            size="xs"
            c="gray.7"
            fw={600}
            truncate
            style={{ maxWidth: 180 }}
          >
            {assetName || "Selected object"}
          </Text>
          <Box
            component="button"
            onClick={onDeselect}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 2,
              display: "flex",
              alignItems: "center",
              color: "rgba(0,0,0,0.4)",
            }}
          >
            <IconX size={12} />
          </Box>
        </Group>
        <Group gap={8}>
          <Button
            color="orange"
            size="sm"
            leftSection={<IconArrowsMove size={14} />}
            onClick={onMove}
          >
            Move
          </Button>
          <Button
            color="red"
            size="sm"
            leftSection={<IconTrash size={14} />}
            onClick={onDelete}
          >
            Delete
          </Button>
        </Group>
        <Text size="xs" c="gray.5" ta="center" mt={4}>
          Esc to deselect / D or Del to remove
        </Text>
      </Box>
    </Box>
  );
}
